import { render, staticRenderFns } from "./AudioView.vue?vue&type=template&id=83756b40"
import script from "./AudioView.vue?vue&type=script&lang=js"
export * from "./AudioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports